import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { SetSubscribersEpicReducerV2 } from "./SetSubscribersV2.epics.js";
const setSubscribersDefaultReducerStateV2 = {
  value: getDefaultAsyncWrapperObj()
};
const setSubscribersReducerV2 = (state = setSubscribersDefaultReducerStateV2, action) => {
  state = SetSubscribersEpicReducerV2.reduxChange(state, action);
  return state;
};
const SetSubscribersReducersMapObjectV2 = {
  setSubscribersV2: setSubscribersReducerV2
};
export {
  SetSubscribersReducersMapObjectV2,
  SetSubscribersReducersMapObjectV2 as default,
  setSubscribersDefaultReducerStateV2,
  setSubscribersReducerV2
};
//# sourceMappingURL=SetSubscribersV2.ducks.js.map
